import React from 'react';
import Link from '../links/Link/Link';
import classNames from 'classnames';

function CardInner({ href, modal, title, target, hiddenText, children }) {
  const cardInnerClasses = classNames('card__inner', {
    'js-triggers-modal': modal
  });

  if (href) {
    return (
      <Link
        className={cardInnerClasses}
        href={href}
        title={title}
        data-modal-to-launch={modal}
        target={target}
        hiddenText={hiddenText}
      >
        {children}
      </Link>
    );
  }

  return <div className={cardInnerClasses}>{children}</div>;
}

export default CardInner;
